module.exports = __webpack_public_path__ + "img/6.9b748606.webp";